import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import cx from "classnames";
import { getSrc } from "gatsby-plugin-image";
import Link from "../Link";
import ArticleCardBody from "./ArticleCardBody";
import { filterCategories, filterDifficultyTags } from "../../utils";

const ArticleCard = ({
  title,
  excerpt,
  date,
  featuredImageNode,
  tags,
  categories,
  topics,
  linkText,
  linkTo,
  footerBorder = "border-0",
  isTextTruncated = true,
}) => {
  const data = useStaticQuery(graphql`
    query {
      defaultThumbnail: file(
        relativePath: { eq: "images/default-thumbnail.svg" }
      ) {
        publicURL
      }
    }
  `);

  return (
    <Link className="article-card card" to={linkTo}>
      <div className="position-relative">
        <img
          src={
            featuredImageNode
              ? getSrc(
                  featuredImageNode.localFile.childImageSharp.gatsbyImageData
                )
              : data.defaultThumbnail.publicURL
          }
          className="card-img-top"
          alt={title}
        />
      </div>

      <ArticleCardBody
        classNames="card-body"
        title={title}
        excerpt={excerpt}
        date={date}
        {...(tags && { level: filterDifficultyTags(tags.nodes) })}
        {...(categories && {
          categories: filterCategories(categories.nodes, topics),
        })}
        isTextTruncated={isTextTruncated}
      />

      {linkText && (
        <div className={cx("card-footer pb-3", footerBorder)}>{linkText}</div>
      )}
    </Link>
  );
};

export default ArticleCard;
